import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import org.example.garfend.pages.homePage as _org_example_garfend_pages_homePage
import org.example.garfend.pages.portfolio.ProjectDetailPage as _org_example_garfend_pages_portfolio_ProjectDetailPage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Abdelrahman Andelwahab - Portfolio"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _org_example_garfend_pages_homePage()
        }
        ctx.router.register(
            "/portfolio/{project}",
        ) { pageCtx -> 
            _org_example_garfend_pages_portfolio_ProjectDetailPage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("contact-card", org.example.garfend.styles.ContactCardStyle)
        ctx.theme.registerStyle("input", org.example.garfend.styles.InputStyle)
        ctx.theme.registerStyle("header-container", org.example.garfend.styles.HeaderContainerStyle)
        ctx.theme.registerStyle("header-shell", org.example.garfend.styles.HeaderShellStyle)
        ctx.theme.registerStyle("header-nav-shell", org.example.garfend.styles.HeaderNavShellStyle)
        ctx.theme.registerStyle("side-menu-shell", org.example.garfend.styles.SideMenuShellStyle)
        ctx.theme.registerStyle("active-header-link", org.example.garfend.styles.ActiveHeaderLinkStyle)
        ctx.theme.registerStyle("navigation-item", org.example.garfend.styles.NavigationItemStyle)
        ctx.theme.registerStyle("logo", org.example.garfend.styles.LogoStyle)
        ctx.theme.registerStyle("social-link", org.example.garfend.styles.SocialLinkStyle)
        ctx.theme.registerStyle("social-icon-button", org.example.garfend.styles.SocialIconButtonStyle)
        ctx.theme.registerStyle("main-button", org.example.garfend.styles.MainButtonStyle)
        ctx.theme.registerStyle("link-override", org.example.garfend.styles.LinkOverrideStyle)
        ctx.theme.registerStyle("main-image", org.example.garfend.styles.MainImageStyle)
        ctx.theme.registerStyle("footer-link", org.example.garfend.styles.FooterLinkStyle)
        ctx.theme.registerStyle("footer-mono-link", org.example.garfend.styles.FooterMonoLinkStyle)
        ctx.theme.registerStyle("portfolio-cross-platform", org.example.garfend.styles.PortfolioCrossPlatformStyle)
        ctx.theme.registerStyle("portfolio-section", org.example.garfend.styles.PortfolioSectionStyle)
        ctx.theme.registerStyle("portfolio-arrow-icon", org.example.garfend.styles.PortfolioArrowIconStyle)
        ctx.theme.registerStyle("service-card", org.example.garfend.styles.ServiceCardStyle)
        ctx.theme.registerStyle("about-text", org.example.garfend.styles.AboutTextStyle)
        ctx.theme.registerStyle("stats-grid", org.example.garfend.styles.StatsGridStyle)
        ctx.theme.registerStyle("back-button", org.example.garfend.styles.BackButtonStyle)
        ctx.theme.registerStyle("app-icon", org.example.garfend.styles.AppIconStyle)
        ctx.theme.registerStyle("info-section", org.example.garfend.styles.InfoSectionStyle)
        ctx.theme.registerStyle("app-store-button", org.example.garfend.styles.AppStoreButtonStyle)
        ctx.theme.registerStyle("app-store-primary-button", org.example.garfend.styles.AppStorePrimaryButtonStyle)
        ctx.theme.registerStyle("glowing-button", org.example.garfend.styles.GlowingButtonStyle)
        ctx.theme.registerStyle("back-to-top-button", org.example.garfend.styles.BackToTopButtonStyle)
        org.example.garfend.updateTheme(ctx)
        org.example.garfend.styles.initRamadanAnimations(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        org.example.garfend.MyApp {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
